import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function idRequiredValidator(control): ValidationErrors | null {
  const value = control.value;
  if (value && (value.id || typeof value == 'number')) {
    return null;
  } else if (value == '') {
    return null;
  } else {
    return { idRequired: true }
  }
}


export function idRequiredValidatorWithParam(param): ValidatorFn {

  return (control: AbstractControl): { [key: string]: boolean } | null => {

    const value = control.value;

    if ((param && param == 'cnpj') && (value && value.length >= 12 && value.length <= 14)) {
      return null;
    } else {
      return { idRequired: true }
    }
  }
}
